<div class="footer d-flex justify-content-between border-0">
  <button type="button" class="btn btn-success font-weight-bold" (click)="emitResponse(0)">
    Confirm
  </button>
</div>